import { TextBody } from '@/design-system/components/typography';
import { formatAmountByDecimals } from '@/utils/numberFormatting';
import { UserEarnOfferListResponseDataItem } from '@utx/utx-client';
import { FlatList, View } from 'dripsy';
import React from 'react';
import { CurrenciesIcon, CurrencyIconVariant } from '../CurrenciesIcon';

import { PopularOfferItemNative } from './PopularOfferItemNative';

interface PopularOffersGroupNativeProps {
  offers: Array<UserEarnOfferListResponseDataItem>;
  onSubscribe: (offerId: string) => void;
}

export const PopularOffersGroupNative: React.FC<PopularOffersGroupNativeProps> = ({ offers, onSubscribe }) => {
  const offersByAsset = offers.reduce((acc, offer) => {
    const asset = offer.asset;
    if (!acc[asset]) {
      acc[asset] = [];
    }
    acc[asset].push(offer);
    return acc;
  }, {} as Record<string, Array<UserEarnOfferListResponseDataItem>>);

  return (
    <FlatList
      data={Object.keys(offersByAsset)}
      renderItem={({ item }) => {
        const offers: Array<UserEarnOfferListResponseDataItem> = offersByAsset[item];
        const { minApy, maxApy } = offers.reduce(
          (acc, offer) => {
            if (offer.estimatedApy < acc.minApy) {
              acc.minApy = offer.estimatedApy;
            }
            if (offer.estimatedApy > acc.maxApy) {
              acc.maxApy = offer.estimatedApy;
            }
            return acc;
          },
          { minApy: Infinity, maxApy: -Infinity }
        );
        let apyRange = `APY ${formatAmountByDecimals({ value: minApy, decimals: 2 })}% ~ ${formatAmountByDecimals({
          value: maxApy,
          decimals: 2
        })}%`;
        if (minApy === maxApy) {
          apyRange = '';
        }

        return (
          <View sx={{ mb: '$4' }}>
            <View sx={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginX: '$4', mb: '$3' }}>
              <CurrenciesIcon asset={item} variant={CurrencyIconVariant.native} />
              <TextBody semiBold success>
                {apyRange}
              </TextBody>
            </View>
            <FlatList
              data={offers}
              numColumns={2}
              columnWrapperStyle={{ gap: 12, paddingHorizontal: 16 }}
              renderItem={({ item }) => {
                return <PopularOfferItemNative offer={item} onPress={() => onSubscribe(item.id)} sx={{ flex: 1, width: '100%' }} />;
              }}
            />
          </View>
        );
      }}
    />
  );
};
